import styles from './Footer.module.scss';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      &copy; 2022 Nicolas Lunardi
    </footer>
  )
}

export default Footer;